class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.historyList = document.querySelector("#search-history-list");
    this.historyDrawerList = document.querySelector("#search-history-list-drawer")

    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
      this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    }
  }

  loadSearchHistory() {
    const history = JSON.parse(localStorage.getItem("searchHistory")) || [];
    if (this.historyList) this.historyList.innerHTML = "";
    if (this.historyDrawerList) this.historyDrawerList.innerHTML = "";
    history.forEach((term) => {
      const li = document.createElement("li");
      li.className = "search-history__item";
      li.innerHTML = `
        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.96452 1.5C11.0257 1.5 13.5 3.96643 13.5 7C13.5 10.0336 11.0257 12.5 7.96452 12.5C6.12055 12.5 4.48831 11.6051 3.48161 10.2273L3.03915 9.6217L1.828 10.5066L2.27046 11.1122C3.54872 12.8617 5.62368 14 7.96452 14C11.8461 14 15 10.87 15 7C15 3.13001 11.8461 0 7.96452 0C5.06835 0 2.57851 1.74164 1.5 4.23347V2.75V2H0V2.75V6.25C0 6.66421 0.335786 7 0.75 7H3.75H4.5V5.5H3.75H2.63724C3.29365 3.19393 5.42843 1.5 7.96452 1.5ZM8.75 4.25V3.5H7.25V4.25V6.8662C7.25 7.20056 7.4171 7.51279 7.6953 7.69825L9.08397 8.62404L9.70801 9.0401L10.5401 7.79199L9.91603 7.37596L8.75 6.59861V4.25Z" fill="#808080" style="fill:#808080;fill:color(display-p3 0.5000 0.5000 0.5000);fill-opacity:1;"/>
        </svg>
        <a href="/search?q=${encodeURIComponent(term)}">${term}</a>`;
      if (this.historyList) this.historyList.appendChild(li);
      if (this.historyDrawerList) this.historyDrawerList.appendChild(li.cloneNode(true));
    });
  }

  saveSearchTerm(term) {
    if (!term.trim()) return;
    let history = JSON.parse(localStorage.getItem("searchHistory")) || [];
    history = history.filter((item) => item !== term);
    history.unshift(term);
    history = history.slice(0, 5);
    localStorage.setItem("searchHistory", JSON.stringify(history));
    this.loadSearchHistory();
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add("hidden");
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }
  }

  onFormSubmit(event) {
    const term = this.input.value.trim();
    if (term) {
      this.saveSearchTerm(term);
    }
  }

  connectedCallback() {
    this.loadSearchHistory();
  }
}

customElements.define("search-form", SearchForm);

// Always load search history when the page loads, regardless of whether
// the <search-form> custom element is used (e.g. when predictive search is enabled).
document.addEventListener("DOMContentLoaded", () => {
  const historyList = document.querySelector("#search-history-list");
  const historyDrawerList = document.querySelector("#search-history-list-drawer");

  const renderHistory = () => {
    const history = JSON.parse(localStorage.getItem("searchHistory")) || [];
    [historyList, historyDrawerList].forEach((list) => {
      if (!list) return;
      list.innerHTML = "";
      history.forEach((term) => {
        const li = document.createElement("li");
        li.className = "search-history__item";
        li.innerHTML = `
          <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.96452 1.5C11.0257 1.5 13.5 3.96643 13.5 7C13.5 10.0336 11.0257 12.5 7.96452 12.5C6.12055 12.5 4.48831 11.6051 3.48161 10.2273L3.03915 9.6217L1.828 10.5066L2.27046 11.1122C3.54872 12.8617 5.62368 14 7.96452 14C11.8461 14 15 10.87 15 7C15 3.13001 11.8461 0 7.96452 0C5.06835 0 2.57851 1.74164 1.5 4.23347V2.75V2H0V2.75V6.25C0 6.66421 0.335786 7 0.75 7H3.75H4.5V5.5H3.75H2.63724C3.29365 3.19393 5.42843 1.5 7.96452 1.5ZM8.75 4.25V3.5H7.25V4.25V6.8662C7.25 7.20056 7.4171 7.51279 7.6953 7.69825L9.08397 8.62404L9.70801 9.0401L10.5401 7.79199L9.91603 7.37596L8.75 6.59861V4.25Z" fill="#808080" style="fill:#808080;fill:color(display-p3 0.5000 0.5000 0.5000);fill-opacity:1;"/>
          </svg>
          <a href="/search?q=${encodeURIComponent(term)}">${term}</a>`;
        list.appendChild(li);
      });
    });
  };

  const saveAndRefresh = (term) => {
    if (!term.trim()) return;
    let history = JSON.parse(localStorage.getItem("searchHistory")) || [];
    history = history.filter((item) => item !== term);
    history.unshift(term);
    history = history.slice(0, 5);
    localStorage.setItem("searchHistory", JSON.stringify(history));
    renderHistory();
  };

  // Initial render
  renderHistory();

  // Save term on predictive-search form submit (works when predictive_search_enabled = true)
  document.querySelectorAll("form[role='search']").forEach((form) => {
    form.addEventListener("submit", () => {
      const input = form.querySelector('input[type="search"]');
      if (input && input.value.trim()) {
        saveAndRefresh(input.value.trim());
      }
    });
  });
});

function debounce(fn, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
}
